import { render, staticRenderFns } from "./CreateDppOfferComponent.vue?vue&type=template&id=60f3c6d0&"
import script from "./CreateDppOfferComponent.vue?vue&type=script&lang=js&"
export * from "./CreateDppOfferComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports